import Building from '../Building/Building.jsx';
import Wrapper from '../../assets/wrappers/JobsContainer';
import { useAllBuildingsContext } from '../../pages/AllBuildings.jsx';
import BuildingPaginationContainer from './BuildingPaginationContainer.jsx';
const BuildingsContainer = () => {
  const { data } = useAllBuildingsContext();

  const {buildings, totalBuildings, numOfPages} = data;

  if (buildings.length === 0) {
    return (
      <Wrapper>
        <h5>לא נמצאו בניינים להציג...</h5>
      </Wrapper>
    );
  }

  return (
    <Wrapper>
      <h5>
        נמצאו {totalBuildings} מסכים 
      </h5>
      <div className='jobs'>
        { buildings.map((building) => {
          return <Building key={building._id} {...building} />;
        })}
      </div>
      {numOfPages > 1 && <BuildingPaginationContainer />}
    </Wrapper>
  );
};

export default BuildingsContainer;
